import React from 'react'
import parse, { HTMLReactParserOptions } from 'html-react-parser';
import Image from 'next/image';
import styles from './styles.module.scss';



interface IBlogPostBodyProps {
  blogPostBodyData: string;
}
interface IHtmlStringAndVideoProps {
  htmlString: string;
}

const HtmlWithNextImage = (
  { htmlString }: IHtmlStringAndVideoProps
) => {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode.type === 'tag' && domNode.name === 'img') {
        const { src, alt, width, height, class: className } = domNode.attribs;

        return (
          <Image
            src={src}
            alt={alt || ''}
            // width={parseInt(width) || 800}
            // height={parseInt(height) || 600}
            width={1280}
            height={parseInt(height) || 600}
            className={className}

            style={{ 
              width: '100%', 
              height: 'auto' 
            }}
            quality={100}
          />
        );
      }
      if (domNode.type === 'text') {
        if (domNode.data.slice(-3) === "mp4" ) {
          return (
            <iframe
              src={domNode.data}
              frameBorder="0"
              // allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              width="100%" 
              height="500"
              loading="lazy"
            />
          )
        }
      }
    },
  };

  return <div>{parse(htmlString, options)}</div>;
};

const BlogPostBody = (
  { blogPostBodyData }: IBlogPostBodyProps
) => {
  return (
    <>
      <HtmlWithNextImage 
        htmlString={blogPostBodyData}
      />
    </>
  );
};

export default BlogPostBody;
